var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"nav-toggle",on:{"click":_vm.openNav}},[_c('icon-bars'),_vm._v(" "),_c('span',{staticClass:"nav-toggle__text"},[_vm._v(_vm._s(_vm.$t('menu.title')))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3279e5d8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/topbar/NavToggle.vue
// module id = null
// module chunks = 